import React from 'react';
import Monitoring from './Monitoring';

const MonitoringOverview = () => {
  return <Monitoring mainView="overview" />;
};

export default MonitoringOverview;
